// src/components/ServiceTile.tsx
import React from 'react';

interface ServiceTileProps {
  icon: string;
  name: string;
  selected: boolean;
  onSelect: (name: string) => void;
  badge?: string;
}

const ServiceTile: React.FC<ServiceTileProps> = ({ icon, name, selected, onSelect, badge }) => {
  return (
    <div
      className={`cursor-pointer border rounded-lg p-4 flex flex-col items-center justify-center transition-all duration-200 relative ${
        selected ? 'border-blue-600 bg-blue-50 shadow-lg' : 'border-gray-200 hover:shadow-lg'
      }`}
      onClick={() => onSelect(name)}
    >
      {badge && (
        <span className="absolute top-2 right-2 inline-flex items-center gap-x-1.5 py-0.5 px-2 rounded-full text-xs font-bold border border-red-500 text-red-500">
          {badge}
        </span>
      )}
      <span className="material-symbols-outlined text-4xl text-gray-700">{icon}</span>
      <span className="mt-2 text-sm font-medium text-center text-gray-800">{name}</span>
    </div>
  );
};

export default ServiceTile;
